/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FunctionPrivilegeViewModel { 
    functionPrivilegeId?: number;
    systemFunctionId?: number;
    privilegeCode?: string;
    privilegeName?: string;
    privilegeNameEnglish?: string;
    privilegeNameLocal?: string;
    isMenuTreeDisplay?: boolean;
    entryUrl?: string;
    sequence?: number;
    hasJurisdictionPermission?: boolean;
    hasScclpermission?: boolean;
    hasSpecialPermission?: boolean;
    updateUserNo?: string;
    updateTime?: Date;
}